<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <div class="baiseback" style="min-height: 100vh;">
                                    <ForumLeft></ForumLeft>
                                </div>

                            </div>
                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>


                    </div>
                    <div :class="(webW?'col-sm-10':'col-sm-12')">
                        <TeamTop></TeamTop>


                        <div class="baiseback">




                            <el-row>
                                <el-col :span="webW?4:8">
                                    <el-input v-model="query.ftitle" placeholder="标题"
                                              class="handle-input mr10"></el-input>
                                </el-col>
                                <el-col :span="webW?4:8">
                                    <el-input v-model="query.unameLike" placeholder="用户名"
                                              class="handle-input mr10"></el-input>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                                </el-col>
                                <el-col :span="8" v-if="webW">
                                    <el-switch

                                            @click="openAutoReflashFunc"
                                            style="float: right;"
                                            active-text="下拉刷新"
                                            v-model="openAutoReflash"
                                            active-color="#13ce66"
                                            inactive-color="#dddddd">
                                    </el-switch>
                                </el-col>
                            </el-row>


                            <div class="  margintop20">
                                <ForumItemTeam></ForumItemTeam>
                            </div>


                            <div class="center" v-if="tableDataloading">
                                <img src="../../../assets/img/loading.gif">
                                <p class="typedesc">数据加载中....</p>
                            </div>


                            <div class="center" style="height: 100vh;" v-if="!tableDataloading&&tableData.length==0">
                                <img src="../../../assets/img/zwsj.png">
                                <p class="typedesc">暂无数据</p>
                            </div>


                            <div class="center">
                                <el-pagination v-if="webW"
                                               @current-change="handlePageChange"
                                               :current-page="query.pageNo"
                                               :page-size="query.pageSize"
                                               layout="total, prev, pager, next"
                                               :total="pageTotal">
                                </el-pagination>


                            </div>

                            <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>

                            <Footer></Footer>

                        </div>

                        <br>
                        <br>
                        <br>
                        <br>

                    </div>
                </div>
            </div>
        </div>
        <div class="h100"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">



    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {
        getTeamForumPage,

    } from '../../../api';

    import Footer from "../Footer";
    import ForumLeft from "../index/ForumLeft";
    import TeamTop from "./TeamTop";
    import ForumItemTeam from "../index/ForumItemTeam";
    import PubSub from "pubsub-js";

    export default {
        name: 'Fans',
        components: {
            Footer,
            ForumLeft,
            TeamTop,
            ForumItemTeam

        },

        data() {

            return {
                webW: true,
                scrolltop: false,
                openAutoReflash: true,

                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,

                fixedRightmenu: false,
                RightMenuWidth: 0,
                lander: {},

                myteaminfo: {},
                Team_typeId: '',


                // 信息
                tableData: [],
                tableDataloading: true,
                tableDataFinish: false,//避免滚动条在最后一直请求

                query: {
                    ftitle: '',
                    unameLike: '',
                    pageNo: 1,
                    pageSize: 9,
                },
                pageTotal: 0,
            };
        },
        methods: {


            openAutoReflashFunc() {
                if (this.openAutoReflash) this.tableDataFinish = false;
            },
            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },
            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData = [];
                this.getTeamForumPage();

                this.tableDataFinish = false;

                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

            },
            handleSearch() {
                this.query.pageNo = 1;
                this.tableData = [];
                this.getTeamForumPage()
            },

            //获取 分页
            getTeamForumPage() {
                this.tableDataloading = true;
                this.tableDataFinish = false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.Team_typeId;


                getTeamForumPage(this.query).then((res) => {
                    this.tableDataloading = false;
                    dealResult(res.data);


                    if (res.data.status == 1) {
                        this.myteaminfo = res.data.obj.myteaminfo;

                        let li = res.data.obj.list;
                        if (li.length == 0) {
                            this.tableDataFinish = true;
                            return;
                        }
                        for(let i=0;i<li.length;i++){
                            li[i].hidden=true;
                            li[i].showComments=false;
                            li[i].commentli=[];
                            li[i].commentliLoading=false;

                            li[i].iscollect="0";
                            li[i].ishit="0";

                            li[i].voteItemli=[];
                            li[i].ivote='0';
                            li[i].myvoteDx='';
                            li[i].myvoteMx=[];

                            li[i].nowvideo={vindex:0,isshow:'0'};
                        }

                        this.tableData= this.tableData.concat(li);
                        PubSub.publish('forumDataListForItem_team',li);


                        this.tableData = this.tableData.concat(li);
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if (this.openAutoReflash) {
                            if (res.data.obj.hasNextPage) this.query.pageNo = res.data.obj.nextPage;
                            else this.query.pageNo = this.query.pageNo + 1;
                        }

                        this.fixedmenu();


                    } else {
                        this.tableDataFinish = true;
                        this.$message.error(res.data.msg)
                    }
                })
            },


            fixedmenu() {

                let JfLeftMenu = document.getElementById('JfLeftMenu');

                let that = this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight;
                    let wh = document.documentElement.clientHeight;


                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = false;
                        }


                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;


                    //滚动条到底部加载数据
                    if (t + wh >= h - 100 && that.openAutoReflash && !that.tableDataFinish) {

                        if (!that.tableDataloading) that.getTeamForumPage();
                    }


                }

            },


        }, mounted() {
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);

            if (this.$route.query.Team_typeId == undefined) {
                sessionStorage.systip = "该群组不存在";
                this.$router.replace("/Tip");
                return;
            }
            if( this.$route.query.TeamIsagree!=undefined)this.query.isAgree = this.$route.query.TeamIsagree;
            else this.query.isAgree ='1';
            this.Team_typeId = this.$route.query.Team_typeId;
            this.getTeamForumPage();

            //固定左右菜单
            this.fixedmenu();

            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;


        }, watch: {
            $route: function (value) {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

                if (value.query.Team_typeId != undefined  && ( value.query.Team_typeId != this.Team_typeId ||  value.query.TeamIsagree != this.query.isAgree )   ) {


                    this.Team_typeId = value.query.Team_typeId;
                    if(value.query.TeamIsagree !=undefined)this.query.isAgree = value.query.TeamIsagree;
                    else this.query.isAgree ='1';
                    this.tableData=[];

                    this.query.pageNo=1;
                    this.query.unameLike='';
                    this.query.ftitle='';
                    this.getTeamForumPage();
                }
            }
        },
        activated() {


            //固定左右菜单
            this.fixedmenu();


        },
        deactivated() {

        }

    };
</script>
<style scoped>
    .mr10 {
        margin-right: 10px;
        width:100%;
    }

    .xiaotouxian{width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;}
.teamforumuname{color: #ff4400;margin-right: 10px;}
</style>
